module.exports = __webpack_public_path__ + "media/components/Hero/needs-hero-01e0cb9a9d5102a93ede58031a552205.jpg";